var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"boolean-wrapper"},[_c('v-btn',{staticClass:"align-self-center",attrs:{"text":"","medium":""},on:{"click":_vm.onAddEmployeeButtonClick}},[_c('v-icon',[_vm._v("transfer_within_a_station")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }